import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import styles from './InvoiceSubmissionTabMenu.module.css';

const InvoiceSubmissionTabMenu = ({
    tabs,
    activeTab,
    handleDelete,
    addNewTab,
    handleSubmitAll,
    canSubmitInvoices = true,
    paymentDetailsMessage = 'Update your payment details in My Profile section to be able to submit invoices.',
    setActiveTab,
}) => {
    const canDeleteInvoices = tabs.length > 1;
    // Titles are derived from the invoice details by the parent, not typed here.
    const getDisplayTabTitle = (tab, index) => {
        const title = String(tab?.title || '').trim();
        if (title === '' || /^Default Invoice \d+$/i.test(title)) {
            return `Default Invoice ${index + 1}`;
        }
        return title;
    };

    return (
        <div className={styles.tabContainter}>
            <div className={styles.tabMenu}>
                {tabs.map((tab, index) => (
                    <div key={tab.id} className={tab.id === activeTab ? `${styles.tabWrapper} ${styles.activeTab}` : styles.tabWrapper}>
                        <div className={styles.tabItem}>
                            <span className={styles.tabId}>
                                {tab.id}.
                            </span>
                            <button
                                type="button"
                                className={tab.id === activeTab ? `${styles.tabInput} ${styles.activeTabText}` : styles.tabInput}
                                title={getDisplayTabTitle(tab, index)}
                                aria-current={tab.id === activeTab}
                                onClick={() => setActiveTab(tab.id)}
                            >
                                {getDisplayTabTitle(tab, index)}
                            </button>
                        </div>
                        <DeleteIcon
                            fontSize="large"
                            className={`${styles.deleteIcon} ${!canDeleteInvoices ? styles.deleteIconDisabled : ''}`}
                            onClick={() => {
                                if (!canDeleteInvoices) return;
                                handleDelete(index);
                            }}
                        ></DeleteIcon>
                    </div>
                ))}
            </div>
            <button className={styles.addButton} onClick={addNewTab}>+ Add Another Invoice</button>
            <button
                className={`${styles.submitButton} ${!canSubmitInvoices ? styles.submitButtonDisabled : ''}`}
                onClick={() => {
                    if (!canSubmitInvoices) {
                        alert(paymentDetailsMessage);
                        return;
                    }
                    handleSubmitAll();
                }}
            >
                Submit All
            </button>
        </div>
    );
};

export default InvoiceSubmissionTabMenu;
